// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__rVQKD","email":"Footer_email__nYijp","copy":"Footer_copy__jHPsw"};